export default function Logo({ className = '', size = 'md' }) {
  return (
    <span className={`in-logo in-logo--${size}${className ? ' ' + className : ''}`}>
      (in)nova
      <span className="in-logo__now">now</span>
    </span>
  );
}
